module.exports = __webpack_public_path__ + "static/media/leslienguyen.9b73e89c.jpeg";